module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "thd-event-emitter"
// module id = 10
// module chunks = 0